declare let $: any;
// const dashboardURL = `${process.env.REACT_APP_REVEAL_DATA_URL}dashboards`;
$.ig.RevealSdkSettings.setBaseUrl(process.env.REACT_APP_REVEAL_BASE_URL);

export const appTheme = (themePreference: string): any => {

    if (themePreference === 'dark') {
        $.ig.RevealSdkSettings.theme = new $.ig.MountainDarkTheme();
        $.ig.RevealSdkSettings.theme.isDark = true;
    } else {
        $.ig.RevealSdkSettings.theme = new $.ig.MountainLightTheme();
        $.ig.RevealSdkSettings.theme.isDark = false;
    }
    var theme = $.ig.RevealSdkSettings.theme.clone();  
    //theme.chartColors = ["rgb(76, 45, 129)","rgb(29, 79, 160)",  "rgb(18, 133, 199)"]
    theme.chartColors = ["rgb(23, 104, 238)","rgb(135, 206, 250)",  "rgb(175, 238, 238)", "rgb(90, 206, 193)", "rgb(226, 105, 81)", "rgb(244, 199, 190)", "rgb(154, 162, 221)", "rgb(219, 223, 233)"]
    theme.regularFont = "Segoe UI";
    theme.mediumFont = "Segoe UI";
    theme.boldFont = "Segoe UI";
    theme.visualizationMargin = 5;
    // theme.visualizationBackgroundColor = "#ccffffff" //"rgba(255, 255, 255, 0.5)";
    // theme.dashboardBackgroundColor = "#00000000";
    return theme;
}
